import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { Box, createTheme, ThemeProvider, Divider } from '@mui/material';
import Container from '@/components/UI/mobile/Container';
import Tab from '@/components/UI/mobile/Tab';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser } from '@/redux/slices/userSlice';
import { RootState } from '@/redux/store';
import { ResponseData as GetListResponseData } from '@/types/api/questionnaire/getQuestionnaireTitleFontDesk';
import { QuestionForm } from './components/QuestionnaireForm/types';
import QuestionnaireListCell from './components/QuestionnaireListCell';
import QuestionnaireForm from './components/QuestionnaireForm';

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#1F2D49',
        },
      },
    },
  },
});

const MobileQuestionnaireList: React.FC = () => {
  const [tab, setTab] = useState(0);
  const [form, setForm] = useState<QuestionForm>({
    show: false,
    req: null,
  });

  const selectedFormType = useMemo(
    () => (tab === 0 ? 'byHouse' : 'byPerson'),
    [tab]
  );

  const [data, setData] = useState<GetListResponseData>({
    byHouse: [],
    byPerson: [],
  });

  const [trigger, setTrigger] = useState({});

  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  const getQuestionnaireList = useCallback(async () => {
    try {
      const res = await axios.get<GetListResponseData>(
        '/ezcon/api/getQuestionnaireTitleFontDesk',
        {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
          params: {
            userId: user.auth.user._id,
          },
        }
      );
      setData(res.data);
    } catch (err) {
      console.error(err);
    }
  }, [user]);

  useEffect(() => {
    if (!user.auth.user._id) {
      dispatch(fetchUser());
    } else {
      getQuestionnaireList();
    }
  }, [user, dispatch, getQuestionnaireList, trigger]);

  return (
    <Container
      sx={{
        fontSize: '3.6vw',
        display: 'flex',
        flexDirection: 'column',
        '@media (orientation: landscape)': {
          fontSize: '1.8vw',
        },
      }}
    >
      <ThemeProvider theme={theme}>
        <Tab options={['戶號問卷', '個人問卷']} onChange={setTab} />
        <Box
          sx={{
            height: '50%',
            flexGrow: 1,
            overflowY: 'auto',
          }}
        >
          {data[selectedFormType].map((item, index, arr) => (
            <React.Fragment key={item.title}>
              <QuestionnaireListCell
                {...{
                  ...item,
                  setForm,
                  selectedFormType,
                  userId: user.auth.user._id,
                }}
              />
              {index !== arr.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Box>
      </ThemeProvider>
      {form.show && (
        <QuestionnaireForm
          form={form}
          setForm={setForm}
          setTrigger={setTrigger}
        />
      )}
    </Container>
  );
};

export default MobileQuestionnaireList;
